import { IAccountOption } from '../../../../providers/venue-provider';

import PositionsBody from './positions-body';
import './styles.scss';

interface PositionsProps {
  accountOption: IAccountOption;
}

const Positions = ({ accountOption }: PositionsProps) => {
  return (
    <div className="positions-container">
      <PositionsBody accountOption={accountOption} />
    </div>
  );
};

export default Positions;
